const CheckboxGroupComponent = {
    templateUrl: '/formViewer/component/checkboxGroup/checkboxGroup.tpl.html',
    controller: 'checkboxGroupController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('checkboxGroup', CheckboxGroupComponent);
